import React, { useContext } from 'react'
import { useAppSelector } from '../../../../../hooks/useReduxHooks'
import { selectAuth } from '../../../../../store/slices'
import {
    IdentiaRoleContext,
    useLazyGetUserByIdQuery,
    useRemoveRoleFromUserMutation,
} from '../../../../../store/api/identia'
import { AuthContext } from '../../../../../context/auth/AuthProvider'
import SpinnerModal from '../../../../general/spinner/SpinnerModal'

interface DeleteUserProps {
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    userId: string
}

export const DeleteUser = ({ setShowModal, userId }: DeleteUserProps) => {
    const { entity } = useAppSelector(selectAuth)
    const { user: authContext } = useContext(AuthContext)
    const platformId = authContext.platform.id || 'multiedu'
    const activeEntityId = entity || authContext.dataEntity?._id || ''

    const [getUserDetail, { isLoading: isFetchingUser }] = useLazyGetUserByIdQuery()
    const [removeRole, { isLoading: isRemoving }] = useRemoveRoleFromUserMutation()

    const closeModal = () => setShowModal(false)

    const handleDeleteUser = async () => {
        try {
            const userDetail = await getUserDetail({
                userId,
                platform_id: platformId,
                entity_id: activeEntityId,
            }).unwrap()

            const roleToRemove = userDetail.platform?.roles?.find(
                (r: any) => r.context_id === activeEntityId || r.context_id === platformId
            )

            if (!roleToRemove) {
                console.warn('No se encontró un rol asociado a este contexto en platform.roles')
                closeModal()
                return
            }

            await removeRole({
                userId,
                roleId: roleToRemove.id,
                context_type: roleToRemove.context_type as IdentiaRoleContext,
                context_id: roleToRemove.context_id!,
            }).unwrap()

            closeModal()
        } catch (error) {
            console.error('Error al intentar desvincular al usuario:', error)
        }
    }

    const isLoading = isFetchingUser || isRemoving

    return (
        <div className="main_Delete">
            <div className="headModal">
                <h3>Aviso</h3>
                <i className="fas fa-times-circle" onClick={closeModal} />
            </div>
            <div className="bodyModals">
                <p>¿Está seguro de eliminar este usuario?</p>
                <div className="containerSpinner_center">
                    <button onClick={closeModal} disabled={isLoading}>
                        Cancelar
                    </button>
                    {isLoading ? (
                        <div className="containerSpinner">
                            <SpinnerModal />
                        </div>
                    ) : (
                        <button className="saveButton" onClick={handleDeleteUser}>
                            Aceptar
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}
